import {getAspectRatioFromImage, getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import Reveal from "@/animations/Reveal";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Image from "@/components/common/Image";

const StyledSingleTileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	border: 1px solid ${props => props.theme.colors.richBlack};
    padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
    padding-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        padding: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
		margin-bottom: unset;
    }
	
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(16)} ${getCssSizeValue(24)} ${getCssSizeValue(32)};
		padding-bottom: ${getCssSizeValue(32)};
		min-height: ${getCssSizeValue(320)};
    }
	
	&.rectangle {
		border: 1px solid ${props => props.theme.colors.richBlack};
		border-top: none;
		position: relative;
		padding: 12px;
		justify-content: space-between;
		margin-bottom: 0;
		&:first-child {
			border-left: 1px solid ${props => props.theme.colors.richBlack};
			border-top: 1px solid ${props => props.theme.colors.richBlack};
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			border: 1px solid ${props => props.theme.colors.richBlack};
			&:first-child {
				border-bottom: none;
				border-right: none;
			}
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			border: 1px solid ${props => props.theme.colors.richBlack};
			border-left: none;
			padding: ${getCssSizeValue(24)};
			&:first-child {
				border: 1px solid ${props => props.theme.colors.richBlack};
				border-right: none;
			}
			&:nth-child(2) {
				border: 1px solid ${props => props.theme.colors.richBlack};
				border-right: none;
			}
			&:nth-child(3) {
				border: 1px solid ${props => props.theme.colors.richBlack};
			}
		}
		.description {
			padding: 0 8px 8px 8px;
			@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				padding: 0;
			}
		}
	}
`

const StyledImageWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
    margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        margin-bottom: ${getCssSizeValue(80, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        margin-bottom: ${getCssSizeValue(56)};
    }
	
	&.rectangle {
		margin-bottom: ${getCssSizeValue(15, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(60, BREAKPOINTS.DESKTOP)};
		} 
	}
`

const StyledImage = styled(Image)` 
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || '16/9'};
    width: auto;
    height: ${getCssSizeValue(60, BREAKPOINTS.MOBILE)};
	
    @media (min-width: ${({theme}) => theme.breakpoints.tablet || 768}px) {
        height: ${getCssSizeValue(80, BREAKPOINTS.TABLET)};
	}

    @media (min-width: ${({theme}) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
        height: ${getCssSizeValue(100)};
	}
`

export default function HowWeHelpTile({ item, isRectangle }) {
	const content = item?.content || ''
	const aspectRatio = getAspectRatioFromImage(item?.icon || {})
	const imageUrl = item?.icon?.url || ''
	const imageAlt = item?.icon?.alt || ''

	return (
		<StyledSingleTileWrapper
			className={isRectangle ? 'rectangle col-mobile-8 col-tablet-4 col-desktop-3' : 'col-mobile-8 col-tablet-4 col-desktop-4'}
		>
			<Reveal onInView once>
				<StyledImageWrapper className={isRectangle ? 'rectangle' : ''}>
					<StyledImage
						src={imageUrl}
						alt={imageAlt}
						sizes={'100vw'}
						$aspectRatio={aspectRatio}
					/>
				</StyledImageWrapper>
				<div
					className='typo-strawford typo-strawford-14 description'
					dangerouslySetInnerHTML={getHtmlFromRedactorField(content)}
				/>
			</Reveal>
		</StyledSingleTileWrapper>
	)
}
